// Calculated Report State

import { CalculateReportModel } from '../model/calculate-report.model';

export const calculatedReportFeatureKey = 'calculated-report';

export interface CalculatedReportState {
  data: CalculateReportModel | null;
  loading: boolean;
  error: string | null;
  templateOid: number | null;
}

export const initialCalculatedReportState: CalculatedReportState = {
  data: null,
  loading: false,
  error: null,
  templateOid: null,
};
